/* 🤖 this file was generated by svg-to-ts*/
export const iconCheck = {
  name: 'check',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.795 15.875l-3.47-3.47a.996.996 0 10-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.58-10.58a.996.996 0 10-1.41-1.41l-9.88 9.87z"/></svg>`,
}
